module.exports = __webpack_public_path__ + "0d1787667a5c3675ea4ebec35fa4ce36.otf";